import { render } from "./SubscriptionPlans.vue?vue&type=template&id=4b11147a&scoped=true"
import script from "./SubscriptionPlans.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlans.vue?vue&type=script&lang=js"

import "./SubscriptionPlans.vue?vue&type=style&index=0&id=4b11147a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b11147a"]])

export default __exports__